import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import RecommendationCard from "@/modules/recommendation/recommendation-card";

import { useHideInterventionSectionRecommendation } from "./intervention-section-recommendation.hook";

import "./intervention-section-recommendation.style.less";

const InterventionSectionRecommendation = () => {
  const hideRecommendation = useHideInterventionSectionRecommendation();
  const { interventionAsset, intervention, observation, observationQuery } =
    useInterventionSectionContext();
  if (hideRecommendation) return null;

  return (
    <div className="intervention-section-recommendation">
      <RecommendationCard
        interventionAsset={interventionAsset}
        intervention={intervention}
        observation={observation}
        loading={observationQuery.isLoading}
        disabled={!intervention.is_editable}
      />
    </div>
  );
};

export default InterventionSectionRecommendation;
